/**
 * BIK (Benefits in Kind) Constants
 * 
 * Centralized constants for BIK calculations and display.
 * Single source of truth for frontend BIK-related values.
 */

// IRAS 3/7 Rule Constants
export const BIK_3_7_RATE = 3 / 7; // 0.42857142857142855
export const BIK_3_7_PERCENTAGE = 42.86; // Rounded for display
export const BIK_3_7_FRACTION = '3/7';
export const BIK_3_7_DESCRIPTION = 'IRAS 3/7 Rule';

/**
 * Format BIK rate as percentage string
 * @returns {string} e.g., "42.86%"
 */
export const formatBIKRateAsPercentage = () => {
  return `${BIK_3_7_PERCENTAGE}%`;
};

/**
 * Format BIK rate as fraction string
 * @returns {string} e.g., "3/7"
 */
export const formatBIKRateAsFraction = () => {
  return BIK_3_7_FRACTION;
};

/**
 * Get full BIK policy description
 * @returns {string} e.g., "IRAS 3/7 Rule (42.86%)"
 */
export const getBIKPolicyDescription = () => {
  return `${BIK_3_7_DESCRIPTION} (${formatBIKRateAsPercentage()})`;
};

/**
 * Get BIK calculation formula text
 * @returns {string} e.g., "Running Costs × 42.86% (IRAS 3/7 Rule)"
 */
export const getBIKFormulaText = () => {
  return `Running Costs × ${formatBIKRateAsPercentage()} (${BIK_3_7_DESCRIPTION})`;
};
